<template>
	
	<div class="flex flex-col c-box"  @click.stop>
		<div class="header-box">
			<p style="width: 90%; margin: 0 auto"  :title="preViewData.zpname" class="nowrap">
				{{ preViewData.zpname  }}
			</p>
			<div class="close-box" @click="closePreview">×</div>
		</div>
		<div class="centent-box">
			   	<div  class="review-content"  >
		          <a-table
		            class="table"
		            :columns="columns"
		            :data-source="reviewData.dataList"
		            bordered
		            :pagination="false"
		            :rowKey="(record) => record.id"
					v-if="izScoring"
		          >
		            <span slot="oneTarget" slot-scope="text">{{ text }}</span>
		            <template slot="itemScore" slot-scope="text, record">
		                <span style="width:100%;"   >{{ text || '' }}</span>
		            </template>
		            <template  slot="content" slot-scope="text, record">
					     <div >
					     <span style="white-space: pre-line;text-align: left;font-size: 18px;line-height: 28px;display: block;">{{transform(text)}}</span>
					    </div>
          			</template>
		          </a-table>
		          <div class="target-score" v-if="izScoring">
		            <span>
		              指标总分值：
		              <span class="number">{{ targetTotalScore }}</span>
		              <span class="score">分</span>
		            </span>
		            <span style="margin-left: 30px">
		              总得分：
		              <span class="number">{{ totalPoints }}</span>
		              <span class="score">分</span>
		            </span>
		          </div>
		          <div class="expertReviews" v-if="izReview">
		            <div class="expertReviews-title">专家评语</div>
		            <a-textarea
		              class="remark-input"
		              v-model="reviewData.remark"
		              placeholder=""
		              :maxLength="500"
		               readonly=""readonly
		              :auto-size="{ minRows: 4, maxRows: 6 }"
		              :disabled="evaluationTablePreview"
		            />
		          </div>
		          <!--<div class="submit" @click="submit" v-if="!evaluationTablePreview">提交</div>-->
		        </div>
	  </div>
</div>
			
</template>

<script>
import { getAction, postAction  } from "@/api/index";
export default{
		props: {
			preViewData: {
				type: Object,
			},
			expertUserId:{
				type:String,
				default:'',
			},
	},
	mounted(){
		this.getStatus();
		this.getReviewTable();
	},
	data(){
		return {
			
			evaluationTablePreview:false,
			targetTotalScore:0,
			totalPoints:0,
			columns: [
			        {
			          title: "评价维度",
			          dataIndex: "oneTarget",
			          key: "oneTarget",
			          align: "center",
			          width: 120,
			          scopedSlots: { customRender: "oneTarget" },
			          customRender: (text, record, index) => {
			            const obj = {
			              children: record.oneTarget,
			              attrs: {},
			            }
			            obj.attrs.rowSpan = this.columnsInit(record.oneTarget, this.reviewData.dataList, 'oneTarget', index)
			            return obj
			          },
			        },
			        {
			          title: "评价指标",
			          dataIndex: "twoTarget",
			          key: "twoTarget",
			          align: "center",
			        },
			        {
			          title: "评价要点",
			          dataIndex: "content",
			          key: "content",
//			          ellipsis: true,
			          scopedSlots: { customRender: "content" },
			          align: "center",
			        },
			        {
			          title: "分值",
			          dataIndex: "score",
			          key: "score",
			          width: 80,
			          align: "center",
			        },
			        {
			          title: "得分",
			          dataIndex: "itemScore",
			          key: "itemScore",
			          align: "center",
			          width: 130,
			          scopedSlots: { customRender: "itemScore" },
			        },
			      ],
			      reviewData: {
			        // 专家评语
			        remark: "",
			        // 指标数据
			        dataList: [],
			      },
			      // 评审
			      reviewShow: false,
			      emptyPrompt: false,
			      targetTotalScore: 0,
			      // 总得分
			      totalPoints: 0,
				  izReview:false,
				  izScoring:false,
		}
	},
	methods: {
		 getStatus(){
					getAction('/lx/lxApply/getReviewAndScore',{}).then((res) => {
						if (res.code === 200) {
						this.izScoring=res.result.izScoring==1?true:false;
						this.izReview=res.result.izReview==1?true:false;
						}else{
						this.$message.error(res.message);
						}
					});
		  },
		  transform(text){
    			return String(text).replaceAll("\\n","\n");
    	  },
		  getReviewTable() {
			      let params = {
			        applyType: 4,
			        applyId: this.preViewData.id,
			        expertUserId: this.expertUserId,
			      };
				  if(this.$route.name=='alApply'){
						params.applyType=4;
				  }else{
					params.applyType=1;
				  }
			      getAction("/lx/lxExpertItem/tablelist", params).then((res) => {
			        if (res.code == 200) {
			          this.reviewData = res.result;
			          this.targetTotalScore = 0
			          this.totalPoints = 0
			          this.reviewData.dataList.forEach((item) => {
			            this.targetTotalScore += item.score;
			            this.totalPoints += Number(item.itemScore);
			          });
			          if (!this.reviewData.hasOne) {
			            this.columns = this.columns.filter(
			              (item) => item.title != "评价维度"
			            );
			          }
			        }
			      });
			},
			closePreview() {
				this.$emit("closePreview");
			},
		    // 合并单元格
		    columnsInit(text, data, key, index) {
		      if (index !== 0 && text == data[index - 1][key]) {
		        return 0
		      }
		      let rowSpan = 1 //判断下一行是否相等
		      for (let i = index + 1; i < data.length; i++) {
		        if (text !== data[i][key]) {
		          break
		        }
		        rowSpan++
		      }
		      return rowSpan
		    },
			
	}
}
</script>
<style scoped lang="scss">
     *{
     	font-size: 18px;
     }
	.img-box {
		width: 15px;
		height: 17px;
		margin-right: 8px;
	}
	
	.img-box-min {
		width: 10px;
		height: 12px;
		margin-right: 8px;
	}
	
	.c-box {
		width: 100%;
		height: 100%;
		background: url("../../assets/images/img19.png") no-repeat;
		background-size: 100% 100%;
	}
	
	.c-box-fullscreen {
		width: 100%;
		height: 100%;
		background: #fff;
		/* background: url("../../assets/images/img19.png") no-repeat;
  background-size: 100% 100%;*/
	}
	
	.header-box-fullscreen {
		height: 80px;
		line-height: 78px;
		position: relative;
		text-align: center;
		background: #9A0B00;
		font-size: 28px;
		font-family: Microsoft YaHei;
		font-weight: bold;
		color: #fff;
	}
	
	.header-box {
		height: 80px;
		line-height: 78px;
		position: relative;
		text-align: center;
		background: #9A0B00;
		border-top-left-radius: 15px;
		border-top-right-radius: 15px;
		margin: 0px 19px 0px 9px;
		font-size: 28px;
		font-family: Microsoft YaHei;
		font-weight: bold;
		color: #fff;
	}
	
	.centent-box {
		margin: 0 12px 5px 0;
		padding: 10px 25px;
		height: 80%;
		overflow: auto;
		.box-item{
			margin:20px auto;
			/deep/ .ant-descriptions-item-label{
				width:120px;
			}
			/deep/ .ant-descriptions-item-content{
				width:240px;
			}
		}
    }
	.close-box {
		position: absolute;
		color: #fff;
		font-size: 40px;
		right: 3%;
		cursor: pointer;
		top: -2px;
	}
	
	 .review-content {
			      display: flex;
			      flex-direction: column;
			      justify-content: space-between;
			      height: 100%;
			      padding-bottom: 10px;
			      .table{
			      	 /deep/ .ant-table-thead > tr > th {
	                  font-size: 18px!important;
	                 }
			      	 /deep/ .ant-table-tbody > tr > td {
	                  font-size: 18px;
	                   padding: 15px!important;
	                 }
			      }
			     
	        }
			    .target-score {
			      margin-top: 10px;
			      color: #6c6c6c;
			      text-align: right;
			      .number {
			        font-size: 20px;
			        color: #9A0B00;
			      }
			      .score {
			        color: #9A0B00;
			      }
			    }
			    .expertReviews-title {
			      font-size: 18px;
			    }
			    .expertReviews-title:before {
			      display: inline-block;
			      width: 6px;
			      height: 22px;
			      background: #9A0B00;
			      border-radius: 5px;
			      content: "";
			      /**
			    这个指为正的话 小方块就往上， 为负的话，小方块就往下
			    */
			      vertical-align: middle;
			      margin-right: 6px;
			    }
			    .remark-input {
			      margin-top: 20px;
			      resize: none;
			    }
			    .submit {
			      width: 263px;
			      height: 41px;
			      background: #9A0B00;
			      border-radius: 8px;
			      line-height: 41px;
			      text-align: center;
			      margin: 0 auto;
			      color: #ffffff;
			      margin-top: 30px;
			      cursor: pointer;
			    }	
</style>